import type { UserIncomeReportRowType } from '@econtractor/types';
import vconst from 'utils/helpers/structs/vconst';
import type { ReportUsersObjectFilter } from '../../helper/reportUsersStorage';

const toMoney = (value: number): number => Math.round(value * 100) / 100;

export const filterUsersByObject = (
    users: UserIncomeReportRowType[],
    objectFilter: ReportUsersObjectFilter,
): UserIncomeReportRowType[] => {
    if (objectFilter !== 'closed') return users;

    const result: UserIncomeReportRowType[] = [];
    for (const user of users) {
        const rows = (user.rows || []).filter(
            (row) => Number(row.objectStatus) === vconst.objectFinished,
        );
        if (!rows.length) continue;

        result.push({
            ...user,
            rows,
            amount: toMoney(rows.reduce((sum, row) => sum + (Number(row.amount) || 0), 0)),
            amountRate: toMoney(rows.reduce((sum, row) => sum + (Number(row.amountRate) || 0), 0)),
        });
    }
    return result;
};
